import '../render'
import 'leaflet'
import './lib/leaflet-geojsonext'
import {GeoJSONRenderer} from './lib/geojson-renderer'
import {onDocumentReady} from '../render/utils'

function init() {
  const renderer = new GeoJSONRenderer()
  renderer.loadFiles()
}

onDocumentReady(init)
